// DS: CR35
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getInfoToDisplayImageDeviation } from '../DeviationViews/Dumbo/Image/_helpers';
import UserLink from '../User/Link/UserLink';
import UserAvatar from '../User/Avatar/UserAvatar';
import { AuthorWatchButton } from '../Button';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import { dateToDistanceTrans } from '../Timestamp/functions';
import s from './MiniArtistCard.scss';
export var MiniArtistCard = function (_a) {
    var style = _a.style, user = _a.user, _b = _a.user, profile = _b.profile, stats = _b.stats, details = _b.details, isOwnUser = _a.isOwnUser, dataHook = _a.dataHook;
    var t = useTranslation().t;
    var getBackgroundUrl = function (deviation) {
        var info = getInfoToDisplayImageDeviation({
            deviation: deviation,
            width: 438,
        });
        if (info) {
            return info.pickedImage.src;
        }
    };
    var profilePic = profile && profile.profilePic;
    var backgroundImageSrc = profilePic && getBackgroundUrl(profilePic);
    var backgroundClassName = classnames(s['background'], !backgroundImageSrc && s['no-background']);
    var backgroundStyle = {
        backgroundImage: backgroundImageSrc
            ? "url('".concat(backgroundImageSrc, "')")
            : undefined,
    };
    var joinedDistance = details && dateToDistanceTrans(details.joindate);
    return (React.createElement("div", { className: s['root'], style: style, "data-hook": dataHook },
        React.createElement(UserLink, { user: user, className: s['user-link'] },
            React.createElement("div", { className: backgroundClassName, style: backgroundStyle })),
        React.createElement("div", { className: s['content'] },
            React.createElement(UserAvatar, { user: user, size: 50, className: classnames(s['avatar'], user.usericonDefault && s['avatar-default']) }),
            React.createElement(UserLink, { user: user, className: s['user-link'] }),
            React.createElement("div", { className: s['tagline'] }, profile && profile.tagline),
            React.createElement("div", { className: s['stats'] },
                stats && (React.createElement("div", { className: classnames(s['watchers'], s['stat-item']) },
                    shortenNumber(stats.watchers, 0),
                    ' ',
                    t('miniArtistCard.watchers', {
                        formattedCount: stats.watchers,
                        count: stats.watchers,
                    }))),
                joinedDistance && (React.createElement("div", { className: classnames(s['joined'], s['stat-item']) },
                    "\u00A0|\u00A0",
                    t('miniArtistCard.joinedDateDistance', {
                        distance: t(joinedDistance.key, {
                            count: joinedDistance.value,
                        }),
                    })))),
            !isOwnUser && (React.createElement(AuthorWatchButton, { author: user, className: s['watch-button'] })))));
};
MiniArtistCard.displayName = 'MiniArtistCard';
export default MiniArtistCard;
//# sourceMappingURL=MiniArtistCard.js.map